var pug = require("!../../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (ngRequired, required) {pug_mixins["centered-content"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": "centered-content","layout": "row"},attributes]), true)) + "\u003E\u003Cdiv class=\"content\" layout=\"column\" layout-align=\"start stretch\" flex flex-md=\"90\" flex-lg=\"80\" flex-gt-lg=\"70\" flex-offset-md=\"5\" flex-offset-lg=\"10\" flex-offset-gt-lg=\"15\"\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};
pug_mixins["contentful-component"] = pug_interp = function(component){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-if", "" + component + ".fields.type === 'wide'", true, true)) + "\u003E\u003Cicon-panel" + (" class=\"wide-panel\""+pug.attr("panel", "" + component, true, true)) + "\u003E\u003C\u002Ficon-panel\u003E\u003C\u002Fdiv\u003E";
pug_mixins["centered-content"].call({
block: function(){
pug_html = pug_html + "\u003Cicon-panel" + (" class=\"standard-panel\""+pug.attr("panel", "" + component, true, true)) + "\u003E\u003C\u002Ficon-panel\u003E";
},
attributes: {"ng-if": pug.escape("" + component + ".fields.type !== 'wide'")}
});
};





























pug_mixins["required-radio-container"] = pug_interp = function(name, model, layout){
var block = (this && this.block), attributes = (this && this.attributes) || {};
ngRequired = attributes['ng-required']
required = !ngRequired
layout = layout || 'row'
pug_html = pug_html + "\u003Cmd-radio-group" + (pug.attr("ng-required", ngRequired, true, true)+pug.attr("ng-model", model, true, true)+pug.attr("layout", layout, true, true)+pug.attr("ng-class", "'" + name + "'", true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003Chelp-mate" + (pug.attr("topic", name, true, true)) + "\u003E\u003C\u002Fhelp-mate\u003E\u003C\u002Fmd-radio-group\u003E\u003Cinput-container class=\"hidden-input\"\u003E\u003Cinput" + (pug.attr("ng-required", ngRequired, true, true)+pug.attr("required", required, true, true)+pug.attr("name", name, true, true)+pug.attr("ng-model", model, true, true)+" ng-show=\"false\" aria-label=\"require\"") + "\u003E\u003C\u002Finput-container\u003E";
};








pug_mixins["required-select"] = pug_interp = function(name, model, label){
var block = (this && this.block), attributes = (this && this.attributes) || {};
label = label || name
pug_html = pug_html + "\u003Cinput-container" + (pug.attr("label", label, true, true)) + "\u003E\u003Cmd-select" + (" class=\"required-select big-list\""+pug.attr("ng-model", model, true, true)+pug.attr("ng-class", "'" + name + "'", true, true)+pug.attr("placeholder", label, true, true)+pug.attr("aria-label", label, true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fmd-select\u003E\u003Cinput-container class=\"hidden-input\"\u003E\u003Cinput" + (pug.attr("required", true, true, true)+pug.attr("name", name, true, true)+pug.attr("ng-model", model, true, true)+" ng-show=\"false\" aria-label=\"require\"") + "\u003E\u003C\u002Finput-container\u003E\u003C\u002Finput-container\u003E";
};










































































pug_mixins["rateDisplay"] = pug_interp = function(rate){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + (pug.escape(null == (pug_interp = rate) ? "" : pug_interp)) + "\u003Cimg src=\"\u002Ficons\u002Ficon-percent-pa.svg\" alt=\"percentage pa\"\u003E";
};












pug_html = pug_html + "\u003Cdiv class=\"pre-request\" ng-if=\"vm.requestPreRequest\"\u003E\u003Cp class=\"insufficient-funds\" ng-if=\"!vm.investor.canWithdraw\"\u003E\u003Cspan\u003EMinimum withdrawal amount is \u003Cb\u003E${{ vm.investor.minimumWithdrawal }}\u003C\u002Fb\u003E. Please call \u003C\u002Fspan\u003E\u003Ctenant-anchor anchor-id=\"contact.telephone.main\"\u003E \u003C\u002Ftenant-anchor\u003E\u003Cspan\u003E if you want to withdraw less than this amount. \u003C\u002Fspan\u003E\u003Cspan\u003E Current available funds: \u003Cb\u003E{{ vm.investor.availableFunds | asCurrency }}\u003C\u002Fb\u003E\u003C\u002Fspan\u003E\u003C\u002Fp\u003E\u003Cp ng-if=\"vm.investor.canWithdraw\"\u003EIf you would like to withdraw funds please click \u003Ca id='showForm' ng-click='vm.showRequestForm()'\u003Ehere\u003C\u002Fa\u003E.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"withdrawals\" ng-if=\"!vm.requestPreRequest &amp;&amp; !vm.requestSuccessful &amp;&amp; vm.emailVerified !== undefined\"\u003E\u003Cdiv class=\"request-failed\" ng-if=\"vm.requestFailed\"\u003E\u003Chelp-box\u003E\u003Ch2\u003E\u003Cmd-icon class=\"warning\"\u003Ewarning\u003C\u002Fmd-icon\u003E Funds request failed\u003C\u002Fh2\u003E\u003Cp\u003EThere has been a problem in processing this request. Please contact \u003Ctenant-inline element-id=\"name.short\"\u003E\u003C\u002Ftenant-inline\u003E if the problem persists.\u003C\u002Fp\u003E\u003C\u002Fhelp-box\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"email-verification\" ng-if=\"!vm.emailVerified\"\u003E\u003Chelp-box\u003E\u003Ch2\u003E\u003Cmd-icon class=\"warning\"\u003Ewarning\u003C\u002Fmd-icon\u003E You have not yet verified your email address\u003C\u002Fh2\u003E\u003Cp\u003EPlease check your email for a verification request - it may be in your \"Junk\" mail folder. You will not be able to withdraw funds until your address has been verified.\u003C\u002Fp\u003E\u003Cmd-button class=\"md-raised md-warn ios-rendering-fix\" ng-click=\"vm.resendVerificationEmail()\" aria-label=\"Resend verification email\"\u003EResend Verification Email\u003C\u002Fmd-button\u003E\u003C\u002Fhelp-box\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"withdrawal-request\" ng-if=\"vm.emailVerified &amp;&amp; !vm.requestFailed\"\u003E\u003Cp class=\"balance\"\u003EAvailable for withdrawal: {{ vm.investor.availableFunds | asCurrency }}\u003C\u002Fp\u003E\u003Cdiv class=\"no-bank-details\" ng-if=\"!vm.hasBankDetails()\" layout-align=\"start start\"\u003E\u003Cp class=\"warning\"\u003E\u003Cmd-icon class=\"warning\"\u003Ewarning\u003C\u002Fmd-icon\u003E In order to withdraw funds, you need to provide your bank details. These are managed through your \u003Ca ui-sref=\"investorDashboard.investorSettings\"\u003EMy Details tab\u003C\u002Fa\u003E.\u003C\u002Fp\u003E\u003Cp\u003EOnce your bank details have been set, you can return here to complete your funds withdrawal.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"vm.hasBankDetails()\"\u003E\u003Cform layout=\"column\" name=\"vm.fundWithdrawalForm\" api-form=\"vm.requestFundWithdrawal()\"\u003E\u003Cfieldset ng-disabled=\"!vm.requestFormEntry\"\u003E\u003Cinput-container label=\"Amount to withdraw\"\u003E\u003Cinput ng-disabled=\"!vm.requestFormEntry\" type=\"text\" required name=\"amount\" ng-model=\"vm.details.amount\" ng-currency min=\"{{ vm.investor.minimumWithdrawal }}\" step=\"0.01\" ng-max=\"vm.investor.availableFunds\"\u003E\u003Cng-message when=\"min\"\u003EMinimum withdrawal amount is ${{ vm.investor.minimumWithdrawal }}\u003C\u002Fng-message\u003E\u003Cng-message when=\"max\"\u003EAmount higher than account balance\u003C\u002Fng-message\u003E\u003Cng-message when=\"pattern\"\u003EEnter amount in dollars and cents\u003C\u002Fng-message\u003E\u003C\u002Finput-container\u003E\u003Ch3\u003EBank details\u003C\u002Fh3\u003E\u003Cp\u003EYour withdrawal will be transferred to the bank account below, which you have previously verified. If you wish to change your bank account details please visit your \u003Ca ui-sref=\"investorDashboard.investorSettings\"\u003EMy Details tab\u003C\u002Fa\u003E.\u003C\u002Fp\u003E\u003Cdiv class=\"pairs\"\u003E \u003Cdiv class=\"pair account-name\"\u003E\u003Clabel\u003EAccount name\u003C\u002Flabel\u003E\u003Cspan class=\"value\"\u003E{{vm.details.accountName}}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"pair bsb\"\u003E\u003Clabel\u003EBSB\u003C\u002Flabel\u003E\u003Cspan class=\"value\"\u003E{{vm.details.bsb}}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"pair account-number\"\u003E\u003Clabel\u003EAccount number (ending with)\u003C\u002Flabel\u003E\u003Cspan class=\"value\"\u003E{{vm.details.accountNumber | asMaskedNumeric}}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cmd-checkbox class=\"agree\" name=\"authorised\" required ng-model=\"vm.details.authorised\"\u003EI am  authorised to submit this withdrawal request.\u003C\u002Fmd-checkbox\u003E\u003Cmd-button class=\"md-raised md-accent submit\" ng-if=\"vm.requestFormEntry\" type=\"submit\"\u003ESubmit\u003C\u002Fmd-button\u003E\u003Cmd-progress-circular class=\"md-accent\" ng-if=\"vm.requestInProgress\" md-mode=\"indeterminate\" md-size=\"40\"\u003E\u003C\u002Fmd-progress-circular\u003E\u003C\u002Ffieldset\u003E\u003C\u002Fform\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"success\" ng-if=\"vm.requestSuccessful\"\u003E\u003Cp\u003EYour funds withdrawal for \u003Cb\u003E{{ vm.details.amount | asCurrency }}\u003C\u002Fb\u003E is being processed.\u003C\u002Fp\u003E\u003Cp\u003EYour new account balance is \u003Cb\u003E{{ vm.investor.availableFunds | asCurrency }}\u003C\u002Fb\u003E. We will send an email confirmation of your withdrawal request.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E";}.call(this,"ngRequired" in locals_for_with?locals_for_with.ngRequired:typeof ngRequired!=="undefined"?ngRequired:undefined,"required" in locals_for_with?locals_for_with.required:typeof required!=="undefined"?required:undefined));;return pug_html;};
module.exports = template;